import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { EditorField, SchemaEditorAction, SchemaEditorState } from './schemaEditorReducer'
import { Button, Stack, Typography } from '@mui/material'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import SortableFieldItem from './SortableFieldItem'
import Helper from '../../../helpers/Helper'

interface P {
    field: EditorField
    state: SchemaEditorState
    dispatch: React.Dispatch<SchemaEditorAction>
    onUpdateField: (fieldId: string, updates: Partial<EditorField>) => void
}

const ListFieldConfig = ({ field, state, dispatch, onUpdateField }: P) => {
    const sensors = useSensors(useSensor(PointerSensor))

    return (
        <Stack spacing={2} sx={{ pl: 6 }}>
            <Typography variant='body2' color='text.secondary'>
                Object Fields
            </Typography>
            <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={event => {
                    const { active, over } = event
                    if (!over || active.id === over.id) return

                    const oldIndex = field.childFields.findIndex(
                        f => f._id === active.id
                    )

                    const newIndex = field.childFields.findIndex(
                        f => f._id === over.id
                    )

                    const reordered = [...field.childFields]

                    const [moved] = reordered.splice(oldIndex, 1)
                    reordered.splice(newIndex, 0, moved)

                    onUpdateField(field._id, {
                        childFields: reordered
                    })
                }}>
                <SortableContext
                    items={field.childFields?.map(f => f._id) ?? []}
                    strategy={verticalListSortingStrategy}>

                    {field.childFields?.map(child => (

                        <SortableFieldItem
                            key={child._id}
                            field={child}
                            state={state}
                            dispatch={dispatch}
                            onDelete={id =>
                                onUpdateField(field._id, {
                                    childFields: field.childFields?.filter(
                                        f => f._id !== id
                                    )
                                })}
                            onUpdateField={(id, updates) => {
                                onUpdateField(field._id, {
                                    childFields: field.childFields?.map(f =>
                                        f._id === id ? { ...f, ...updates } : f
                                    )
                                })
                            }}

                        />

                    ))}

                </SortableContext>
            </DndContext>
            <Stack justifyContent='center' alignItems='flex-end'>
                <Button
                    disabled={field.isDefault}
                    onClick={() => {
                        const index = (field.childFields?.length ?? 0) + 1

                        const newField: EditorField = {
                            _id: Helper.generateUUID(),
                            label: 'New Field',
                            key: `${field.key}.field_${index}`,
                            type: 'string',
                            validation: { isRequired: false }
                        }
                        onUpdateField(field._id, {
                            childFields: [...(field.childFields ?? []), newField]
                        })
                    }}
                    variant='outlined'
                    size='small'>
                    + Add Child
                </Button>
            </Stack>
        </Stack>
    )
}

export default ListFieldConfig
